import * as types from '../action.types';

export const initialState = {
  hideArchivedSettings: false
};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.FETCH_SETTINGS_SUCCESS:
      state = action.payload;
      return state;

    case types.UPDATE_SETTINGS_HIDE_ARCHIVED_FILES_SUCCESS:
      state.hideArchivedSessions = action.payload
      return state;

    default:
      return state;
  }
};

export default SettingsReducer;

